import UspBanner from './usp-banner'

export default UspBanner
